import { memo } from 'react';
import { AdminFormRow } from '@ui';
import { ControlledTextInput } from '@lp/features/admin/forms/components/inputs/ControlledTextInput';

type TXCenterBasicDetailsProps = {
  isReadOnly?: boolean;
  isQadCustomerIdReadOnly?: boolean;
};

export const TXCenterBasicDetails = memo(({ isReadOnly, isQadCustomerIdReadOnly }: TXCenterBasicDetailsProps) => {
  return (
    <>
      <AdminFormRow title="TX Center Name" isRequired>
        <ControlledTextInput name="name" aria-label="TX Center Name" isDisabled={isReadOnly} />
      </AdminFormRow>
      <AdminFormRow title="Code" isRequired>
        <ControlledTextInput name="code" aria-label="Code" isDisabled={isReadOnly} />
      </AdminFormRow>
      <AdminFormRow title="QAD Customer ID">
        <ControlledTextInput name="qadCustomerId" aria-label="QAD Customer ID" isDisabled={isQadCustomerIdReadOnly} />
      </AdminFormRow>
    </>
  );
});
